import React from 'react'
import { Link } from 'react-router-dom'

function Catering() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>

        <div className="auto-container">
          <div className="inner">
            <h1>Train Food Delivery at Coimbatore Junction (CBE)</h1>

            <div className="sub_text">
              <p>
                Home -{" "}
                <a href="" className="primary-color">
                  Train Food Delivery
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle">
              <span>Tickling Tummy</span>
            </div>

            <h2>
              <span className="theme_color">Train Food Delivery</span> at Coimbatore
              Junction (CBE)
            </h2>
          </div>

          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Traveling through or departing from Coimbatore Junction? Don’t rely
                on pantry car food or packed meals from random vendors. With
                Tickling Tummy, you can enjoy fresh, homemade, pure-veg food
                delivered directly to your train compartment.
                <br />
                <br />
                Just let us know your train number, arrival time, and platform stop
                at CBE, and we’ll deliver a hot, hygienic meal to your seat—prepared
                just like Amma would, in our R.S. Puram kitchen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5 - Image Left, Content Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix">
            {/* Image Left */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/train-food-delivery-cover.jpg)" }}
                ></div>

                <div className="image">
                  <img
                    src="assets/images/train-food-delivery-cover.jpg"
                    alt="veg combo meals Coimbatore"
                  />
                </div>
              </div>
            </div>

            {/* Content Right */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInRight">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img
                      src="assets/images/train-food-thumbnail.jpg"
                      alt="full meal box Coimbatore"
                    />
                  </div>

                  {/* How It Works */}
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>How It Works</span>
                    </div>

                    <div className="text">
                      <ul>
                        <li>
                          ◆ Message us your train & seat number, and expected
                          arrival time at Coimbatore Junction
                        </li>
                        <li>◆ Place your order in advance</li>
                        <li>
                          ◆ Let us know food preferences (e.g., Jain, satvik, low
                          salt, air-fried, no ghee)
                        </li>
                        <li>
                          ◆ We’ll cook fresh, pack it neatly, and deliver it at your
                          coach during your halt at CBE
                        </li>
                        <li>
                          ◆ Receive and enjoy homemade vegetarian food—delivered
                          with love
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Why Choose Us */}
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Why Choose Us for Train Food?</span>
                    </div>
                    <div className="text">
                      <ul>
                        <li>
                          ◆ Homemade vegetarian meals – clean, wholesome, and
                          comforting
                        </li>
                        <li>
                          ◆ Tailored to your diet – options like low-oil, less
                          spice, sugar-free, Jain-friendly
                        </li>
                        <li>
                          ◆ Timely & organized delivery – straight to your train
                          coach at CBE
                        </li>
                        <li>
                          ◆ No middlemen or platforms – direct from our kitchen to
                          your journey
                        </li>
                        <li>
                          ◆ Ideal for long-distance travelers, pilgrims, elderly
                          passengers, and families
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Popular Meals */}
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Popular Vegetarian Meals for Train Travelers</span>
                    </div>

                    <div className="text">
                      <ul>
                        <li>
                          ◆ South Indian Meal – e.g., meals, sambar rice, curd rice,
                          variety rice
                        </li>
                        <li>
                          ◆ North Indian Meal – e.g., phulka, paneer butter masala,
                          dal tadka, jeera rice
                        </li>
                        <li>
                          ◆ Mini tiffins & snacks – upma, pongal, poha, vada, vada
                          pav, sandwich
                        </li>
                        <li>
                          ◆ Custom boxes – for kids, seniors, Jain, or sugar-free
                          needs
                        </li>
                        <li>◆ Packed hot and safe for train travel</li>
                      </ul>
                    </div>
                  </div>

                  {/* Perfect For */}
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Perfect For...</span>
                    </div>

                    <div className="text">
                      <ul>
                        <li>
                          ◆ Passengers boarding or passing through Coimbatore
                          Junction (CBE)
                        </li>
                        <li>
                          ◆ Families, solo travelers, and groups wanting hygienic
                          food
                        </li>
                        <li>
                          ◆ Tourists and pilgrims heading to Ooty, Palani, Kerala
                          routes
                        </li>
                        <li>
                          ◆ People who prefer home-style meals over pantry car food
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Right Column */}
          </div>
        </div>
      </section>
    </>

  );
}

export default Catering
